module.exports = __webpack_public_path__ + "static/preview-richard-155833f04fc54770046a89f687c63353.wav";